<template>
  <div>

    <b-row class="ml-0">
      <div v-for="state in states" :key="state.id">
        <div class="mb-3">
          <b-button class="my-collapse" v-b-toggle="state.id" @click="() => toggle(state.id)" variant="primary">
            <feather-icon :icon="state.icon" size="12" :class="'text-white'" />
            {{ $t(state.name) }}
            <feather-icon :icon="state.arrow" size="12" :class="'text-white'" />
          </b-button>
        </div>
      </div>
      <br />
    </b-row>
    <slot ></slot>
  </div>
</template>
<script>

import Vue from 'vue';

import store from '@/store'

import {
  VBToggle, BCollapse, BButton, BCard, BIcon, BRow
} from 'bootstrap-vue'
import { reactive, watch } from '@vue/composition-api';

Vue.directive('b-toggle', VBToggle)
export default {
  name: 'ToggaleCollabsable',
  props: { 
    collapses: { type: Array }
  },
  components: {
    BButton, BCard, BCollapse, VBToggle, BIcon, BRow
  },
  setup(props, { root }){

    const closedArrow = store.getters['auth/preferDirIsRtl'] ? 'ArrowLeftIcon' : 'ArrowRightIcon'
    const openArrow = 'ArrowDownIcon'

    let initialStates = {};

    props.collapses.map((collapse)=> {

      let state = collapse;

      state.isOpen = false;

      state.arrow = closedArrow

      initialStates[collapse.id] = state

    })

    const states = reactive(initialStates)

    const toggle = (id) => {

      states[id].isOpen=!states[id].isOpen

      if(states[id].isOpen){
        states[id].arrow = openArrow
      }else{
        states[id].arrow = closedArrow
      }
    }

    return {
      closedArrow,
      openArrow,
      states,
      toggle
    }
  }
}




</script>
<style scoped>
.my-collapse {
  margin-bottom: -25px;
  z-index: 9999;
  margin-right: 25px;


}
</style>